import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Route, Switch } from "react-router-dom";
import ReportCreateSourceIndex from "./ReportCreateSourceIndex";
import ReportCreateSourceId from "./ReportCreateSourceId";
import { getReportCreateSourcePath } from "../../ReportRoutes";
import { getPreBaseRoute } from "../../../../../../components";
const ReportCreateSourceRoutes = () => {
    return (_jsxs(Switch, { children: [_jsx(Route, { path: getPreBaseRoute() + getReportCreateSourcePath() + "/:sourceId", component: ReportCreateSourceId }), _jsx(Route, { path: getPreBaseRoute() + getReportCreateSourcePath(), component: ReportCreateSourceIndex })] }));
};
export default ReportCreateSourceRoutes;
